var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6373 15.1663V10.4997C25.6373 4.66634 23.3103 2.33301 17.4928 2.33301H10.5117C4.6942 2.33301 2.36719 4.66634 2.36719 10.4997V17.4997C2.36719 23.333 4.6942 25.6663 10.5117 25.6663H15.1657",
    stroke: "#807A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 16.9047L11.3356 13.2997C11.7311 12.7864 12.4642 12.6931 12.9761 13.0897L15.1053 14.7697C15.6173 15.1664 16.3503 15.0731 16.7458 14.5714L19.4336 11.0947",
    stroke: "#807A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7028 18.4567L23.0286 19.1217C23.1915 19.4483 23.5987 19.7517 23.9594 19.8217L24.4015 19.8917C25.7279 20.1133 26.0421 21.0933 25.088 22.0617L24.6808 22.47C24.4131 22.75 24.2619 23.2867 24.3434 23.66L24.4015 23.905C24.7622 25.515 23.9129 26.1333 22.5166 25.2933L22.2141 25.1183C21.8534 24.9083 21.2717 24.9083 20.911 25.1183L20.6085 25.2933C19.2006 26.145 18.3513 25.515 18.7236 23.905L18.7818 23.66C18.8632 23.2867 18.712 22.75 18.4444 22.47L18.0371 22.0617C17.0831 21.0933 17.3972 20.1133 18.7236 19.8917L19.1657 19.8217C19.5148 19.7633 19.9336 19.4483 20.0965 19.1217L20.4223 18.4567C21.0506 17.185 22.0745 17.185 22.7028 18.4567Z",
    stroke: "#807A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvents);
export default __webpack_public_path__ + "static/media/no-events.138300c9a48ffcf2d90b74dcf11d7b64.svg";
export { ForwardRef as ReactComponent };